// src/features/dashboard/components/PriorityBadge.tsx
import type { TicketPriority, TicketStatus } from '../types/dashboard.types';

interface PriorityBadgeProps {
  priority: TicketPriority;
}

const PRIORITY_CONFIG: Record<TicketPriority, { label: string; className: string }> = {
  low: { label: 'کم', className: 'vania-badge vania-badge--teal' },
  medium: { label: 'متوسط', className: 'vania-badge vania-badge--sky' },
  high: { label: 'بالا', className: 'vania-badge vania-badge--amber' },
  urgent: { label: 'فوری', className: 'vania-badge vania-badge--rose vania-badge--pulse' },
};

export function PriorityBadge({ priority }: PriorityBadgeProps) {
  const config = PRIORITY_CONFIG[priority];
  return <span className={config.className}>{config.label}</span>;
}

interface TicketStatusDotProps {
  status: TicketStatus;
}

const TICKET_STATUS_CONFIG: Record<TicketStatus, { label: string; dotClassName: string }> = {
  open: { label: 'باز', dotClassName: 'bg-[var(--vania-accent-rose,#ff6b81)]' },
  answered: { label: 'پاسخ داده شده', dotClassName: 'bg-[var(--vania-accent-teal,#2fe0c0)]' },
  pending: { label: 'در انتظار پاسخ', dotClassName: 'bg-[var(--vania-accent-amber,#ffb454)]' },
  closed: { label: 'بسته شده', dotClassName: 'bg-[var(--vania-text-tertiary,#6b7280)]' },
};

export function TicketStatusDot({ status }: TicketStatusDotProps) {
  const config = TICKET_STATUS_CONFIG[status];
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-[var(--vania-text-secondary,#a3aab8)]">
      <span className={`h-1.5 w-1.5 rounded-full ${config.dotClassName}`} />
      {config.label}
    </span>
  );
}
